<template>
    <div class="editor">
        <div class="menubar mb-0" v-if="editor">
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 50 50"
                style="enable-background:new 0 0 50 50;"
                xml:space="preserve"
                class="menubar__button pa-1 pl-0"
                :class="{ 'is-active': editor.isActive('bold') }"
                @click="editor.chain().focus().toggleBold().run()"
                width="20px"
            >
                <g>
                    <path
                        d="M7.2,49.5v-49h18.4c3.7,0,6.7,0.5,9,1.5c2.3,1,4,2.5,5.3,4.6c1.3,2.1,1.9,4.2,1.9,6.5c0,2.1-0.6,4.1-1.7,5.9
		c-1.1,1.9-2.9,3.3-5.1,4.5c3,0.9,5.2,2.4,6.8,4.4c1.6,2.1,2.4,4.6,2.4,7.4c0,2.3-0.5,4.4-1.5,6.4s-2.2,3.5-3.6,4.6
		c-1.4,1.1-3.2,1.9-5.4,2.4c-2.2,0.5-4.8,0.8-7.9,0.8H7.2z M13.7,21.1h10.6c2.9,0,4.9-0.2,6.2-0.6c1.6-0.5,2.9-1.3,3.7-2.4
		c0.8-1.1,1.3-2.6,1.3-4.3c0-1.6-0.4-3.1-1.2-4.3C33.5,8.3,32.4,7.4,31,7c-1.4-0.5-3.9-0.7-7.5-0.7h-9.8V21.1z M13.7,43.7h12.2
		c2.1,0,3.6-0.1,4.4-0.2c1.5-0.3,2.7-0.7,3.7-1.3c1-0.6,1.8-1.5,2.5-2.7c0.6-1.2,1-2.6,1-4.1c0-1.8-0.5-3.4-1.4-4.8
		c-0.9-1.3-2.2-2.3-3.9-2.8c-1.7-0.5-4.1-0.8-7.2-0.8H13.7V43.7z"
                    />
                </g>
            </svg>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 50 50"
                style="enable-background:new 0 0 50 50;"
                xml:space="preserve"
                class="menubar__button pa-1"
                :class="{ 'is-active': editor.isActive('italic') }"
                @click="editor.chain().focus().toggleItalic().run()"
                width="24px"
            >
                <g>
                    <path d="M18.4,49.5L28.6,0.5h6.5L24.9,49.5H18.4z" />
                </g>
            </svg>
            <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 50 50"
                style="enable-background:new 0 0 50 50;"
                xml:space="preserve"
                class="menubar__button pa-1"
                :class="{ 'is-active': editor.isActive('underline') }"
                @click="editor.chain().focus().toggleUnderline().run()"
                width="24px"
            >
                <g>
                    <path
                        d="M36.6,0.6h5.9v25.8c0,4.5-0.5,8-1.5,10.7c-1,2.6-2.8,4.8-5.5,6.4c-2.6,1.7-6.1,2.5-10.4,2.5c-4.2,0-7.6-0.7-10.3-2.2
		c-2.7-1.4-4.6-3.5-5.7-6.3C8,34.9,7.5,31.1,7.5,26.4V0.6h5.9v25.7c0,3.9,0.4,6.7,1.1,8.6c0.7,1.8,2,3.3,3.7,4.2
		c1.8,1,3.9,1.5,6.4,1.5c4.3,0,7.4-1,9.3-3c1.8-2,2.8-5.8,2.8-11.3V0.6z"
                    />
                </g>
                <rect x="3.5" y="45.5" width="43" height="4" />
            </svg>
        </div>

        <editor-content
            :editor="editor"
            class="pa-2 pb-0 text-field-item"
        />
    </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Bold from "@tiptap/extension-bold";
import Italic from "@tiptap/extension-italic";
import Underline from "@tiptap/extension-underline";

export default {
    components: {
        EditorContent
    },
    props: ["classificator_value", "classificator_row", "classificator_type"],
    name: "classificator-tiptap-editor-area",
    data() {
        return {
            editor: null
        };
    },
    mounted() {
        this.editor = new Editor({
            extensions: [
                Document,
                Paragraph,
                Text,
                Bold,
                Italic,
                Underline
            ],
            content: this.classificator_value,
            onUpdate: ({ editor }) => {
                const html = editor.getHTML();
                this.$emit("changeValue", {
                    value: html,
                    classificator_row: this.classificator_row,
                    classificator_type: this.classificator_type
                });
            }
        });
    },
    beforeDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
    }
};
</script>
<style scoped>
.text-field-item {
    border: 1px solid rgba(142, 142, 142, 0.32);
    border-radius: 6px;
}
::v-deep .ProseMirror > p {
    margin-bottom: 9px !important;
}
.is-active {
    fill: lightgray;
}
</style>
